import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_auto.last_sinister.title',
  },
  dateSinister: {
    id: 'dashboard_auto.last_sinister.date_sinister',
  },
  numSinister: {
    id: 'dashboard_auto.last_sinister.num_sinister',
  },
  seeDetails: {
    id: 'dashboard_auto.last_sinister.see_details',
  },
  actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  enCours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  title_sinistre_empty_state: {
    id: 'dashboard_auto.last_sinister.empty_state_title',
  },
});
